
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IAppForm } from './IAppForm'
import { AffiliateModule, ApplicationModule, DataModule, WizardModule } from '@/store'
import EmploymentDto from '../../types/dto/employmentDto'
import LookupValueDto from '../../types/dto/lookupValueDto'
import AddressDto from '../../types/dto/addressDto'
import PrivacyBanner from '@/components/shared/PrivacyBanner.vue'
import { emailRegex } from '../../helpers/email-validator'
import { phoneRegex } from '../../helpers/regex-helper'
import { WizardPage_Enum } from '../../enums/WizardPage_Enum'
import { SegmentService } from '../../services'
import { phoneNormalised } from '../../helpers/phone-normalization-helper'
import VehicleBanner from "@/components/shared/VehicleBanner.vue";
import VehicleBannerV2 from "@/components/shared/VehicleBannerV2.vue";
import { RequestHelper} from '@/helpers/index';

	@Component({
	  name: 'Summary',
	  components: {
			VehicleBanner,
	    PrivacyBanner,
      VehicleBannerV2
	  },
	  filters: {
	    shortDate (value: Date) {
	      return new Date(value).toLocaleDateString()
	    },
	    capitalise (value: string) {
	      return value.substring(0, 1).toUpperCase() + value.substring(1).toLowerCase()
	    },
	    currency (value: number) {
	      const n = Number(value).toFixed(2)
	      const v = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

	      return v.replace('.00', '')
	    }
	  }
	})
export default class Summary extends Vue implements IAppForm {
  // #region Props

		@Prop() wizardIndex!: number;
		// #endregion

		// #region Data

		show = true;
		agreed = false;
		showError = false;


		submitClicked = false;

    vehicle = ApplicationModule.vehicle;

    useVehicleV2 = RequestHelper.getQueryVariable('useVehicleV2');
		// #endregion

		mounted () {
		  this.setEmploymentLength()
		  this.setAddressLength()

      const trustbox = this.$refs.trustbox;
      setTimeout(() => {
        
        if ( (window as any).Trustpilot ) {
          (window as any).Trustpilot.loadFromElement(trustbox);
          var iOS = ( navigator.userAgent.match(/(iPad|iPhone|iPod)/i) ? true : false );
          var ua = navigator.userAgent.toLowerCase();
          var isAndroid = ua.indexOf("android") > -1;

          var w = window.innerWidth;
          if( iOS || isAndroid){

            w = screen.width;
          }
    
          if (w < 420) {
            const parentWidth = w - 30 ;
            const elementWidth = 420;
            const scale = parentWidth / elementWidth;
            const widget = this.$el.querySelector(".trustpilot-widget") as HTMLElement;

            widget.style.transform = `scale(${scale})`;
            widget.style.transformOrigin ='left';
          }
          const widget = this.$el.querySelector(".trustpilot-widget") as HTMLElement;
          widget.style.visibility = 'visible';
        }
      }, 2000);
		}

		// #region Methods

		submit () {
		  if (this.isSubmitting) {
		    return
		  }

		  this.submitClicked = true

		  const valid = this.validate()

		  if (!valid) {
		    return
		  }

		  SegmentService.trackPersonalDetailsCompletedEvent({
		    guid: ApplicationModule.GUID,
		    email: this.value.email,
        date_of_birth: this.value.dateOfBirth,
        first_name: this.value.firstName,
        last_name: this.value.lastName,
        phone_number_normalised: phoneNormalised(this.value.contactNumber),
        postcode: this.value.addresses[0].postcode,
				vehicle_type_id: this.value.vehicleType.id,
				utm: ApplicationModule.utmParameters,
				net_monthly_income: ApplicationModule.form.netMonthlyIncome,
				city: this.value.addresses[0].town,
				gender: ApplicationModule.form.title.id === 1 ? 'male' : 'female',
		  })

		  ApplicationModule.updateIsSubmitting(true)

		  this.$emit('send-full-app', this.value)
		}

		validate () {
		  this.showError = false

		  // Find any errors on the summary
		  const war = document.getElementsByClassName('-warning')
		  const err = document.getElementsByClassName('-error')

		  if (war.length > 0) {
		    // Scroll first instance of error into view
		    (war[0] as HTMLDivElement).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })

		    return false
		  }

		  if (err.length > 0) {
		    // Scroll first instance of error into view
		    (err[0] as HTMLDivElement).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })

		    return false
		  }

		  if (this.agreed === false) {
		    this.showError = true
		    return false
		  }

		  // this.value.agreedToTermsAndConditions = true
		  return true
		}

		goToPage (page: string) {
		  WizardModule.updateCallback(true)
		  ApplicationModule.updateFormCopy(Object.assign({}, this.value))
		  this.$emit('go-to-page', WizardPage_Enum[page as keyof typeof WizardPage_Enum])
		}

		editAddress (index: number) {
		  ApplicationModule.updateIsNewAddress(false)
		  ApplicationModule.updateAddressIndex(-1)
		  ApplicationModule.updateAddress(JSON.parse(JSON.stringify(this.value.addresses[index])))

		  setTimeout(() => { ApplicationModule.updateAddressIndex(index) }, 100)
		  this.goToPage('AddressHistory')
		}

		addAddress () {
		  ApplicationModule.updateIsNewAddress(true)

		  ApplicationModule.updateAddress({
		    yearsAtAddress: 0,
		    monthsAtAddress: 0,
		    residentialStatusLookup: {
		      id: -1
		    } as LookupValueDto
		  } as AddressDto)

		  setTimeout(() => { ApplicationModule.updateAddressIndex(ApplicationModule.form.addresses.length) }, 100)
		  this.goToPage('AddressHistory')
		}

		editEmployment (index: number) {
		  ApplicationModule.updateIsNewEmployment(false)
		  ApplicationModule.updateEditingEmploymentIndex()
		  ApplicationModule.updateEditingEmployment(JSON.parse(JSON.stringify(this.value.employments[index])))

		  setTimeout(() => { ApplicationModule.updateEditingEmploymentIndex(index) }, 100)
		  this.goToPage('EmploymentHistory')
		}

		addEmployment () {
		  ApplicationModule.updateIsNewEmployment(true)
		  ApplicationModule.updateEditingEmployment({
		    yearsAtEmployer: 0,
		    monthsAtEmployer: 0,
		    employmentStatusLookup: {
		      id: -1
		    } as LookupValueDto,
		    employmentLevel: this.value.employments.length
		  } as EmploymentDto)

		  setTimeout(() => { ApplicationModule.updateEditingEmploymentIndex(ApplicationModule.form.employments.length) }, 100)

		  this.goToPage('EmploymentHistory')
		}

		showTandC () {
		  this.$emit('showTandC')
		}

		nameNeeded (employment: EmploymentDto) {
		  if (employment.employmentStatusLookup.id === 9 ||
            employment.employmentStatusLookup.id === 11 ||
            employment.employmentStatusLookup.id === 14 ||
            employment.employmentStatusLookup.id === 15) {
		    return true
		  }
		  return false
		}

		occupationNeeded (employment: EmploymentDto) {
		  if (employment.employmentStatusLookup.id === 9 ||
					employment.employmentStatusLookup.id === 11 ||
          employment.employmentStatusLookup.id === 14 ||
					employment.employmentStatusLookup.id === 10 ||
					employment.employmentStatusLookup.id === 18 ||
					employment.employmentStatusLookup.id === 15) {
		    return true
		  }
		  return false
		}

		numberValid () {
		  if (this.value.contactNumber && RegExp(phoneRegex).test(this.value.contactNumber)) {
		    return true
		  }
		  return false
		}

		emailValid () {
		  if (this.value.email && RegExp(emailRegex).test(this.value.contactNumber)) {
		    return true
		  }
		  return false
		}
		// #endregion

		// #region Computed

    addressLength = 0;

    setAddressLength () {
      let count = 0

      this.value.addresses.forEach(e => {
        count += e.monthsAtAddress ? Number(e.monthsAtAddress) : 0
        count += e.yearsAtAddress ? (Number(e.yearsAtAddress) * 12) : 0
      })

      this.addressLength = count
    }

    employmentLength = 0;

    setEmploymentLength () {
      let count = 0

      this.value.employments.forEach(e => {
        count += e.monthsAtEmployer ? Number(e.monthsAtEmployer) : 0
        count += e.yearsAtEmployer ? (Number(e.yearsAtEmployer) * 12) : 0
      })
      this.employmentLength = count
    }

    get agreedTerms () {
      return ApplicationModule.agreedToTerms
    }

    get value () {
      return ApplicationModule.form
    }

    get vehicleName () {
      const obj = DataModule.vehicles.find(v => v.value === this.value.vehicleType.id)

      return this.value.vehicleType.id && this.value.vehicleType.id > 0 && obj ? obj.label : ''
    }

    get maritalStatusName () {
      const obj = DataModule.maritalStatuses.find(v => v.value === this.value.maritalStatus.id)

      return this.value.maritalStatus.id && this.value.maritalStatus.id > 0 && obj ? obj.label : ''
    }

    get titleName () {
      const obj = DataModule.titles.find(v => v.value === this.value.title.id)

      return this.value.title.id && this.value.title.id > 0 && obj ? obj.label : ''
    }

    get licenseName () {
      const obj = DataModule.drivingLicenses.find(v => v.value === this.value.drivingLicence.id)

      return this.value.drivingLicence.id && obj ? obj.label : ''
    }

    get employmentStatuses () {
      return DataModule.employmentStatuses
    }

    get employmentName () {
      const obj = DataModule.employmentStatuses.find(v => v.value === this.value.employments![0].employmentStatusLookup.id)

      return this.value.employments && this.value.employments.length > 0 && obj ? obj.label : ''
    }

    get residentialStatuses () {
      return DataModule.tenancyTypes
    }

    get affiliate () {
      return AffiliateModule.affiliateConfig ? AffiliateModule.affiliateConfig.displayName : ''
    }

    get isPrePopulatePartner() {
      return AffiliateModule.affiliateConfig && AffiliateModule.affiliateConfig.prePopulateForm ? true : false
    }

    get isSubmitting () {
      return ApplicationModule.isSubmitting
    }

    get callback () {
      return WizardModule.callback
    }

    get showMinErrorForEmployment () {
      return this.value.employments[0].employmentStatusLookup.id === undefined || this.value.employments[0].employmentStatusLookup.id === null
    }

		get getCustomIntro () {
			return AffiliateModule.affiliateConfig && AffiliateModule.affiliateConfig.customIntro && AffiliateModule.affiliateConfig.customIntro === true
		}

    get isBannerVisiable() {
      if( this.vehicle && this.vehicle.vrm &&
          ( this.vehicle.make ||
          this.vehicle.model ||
          this.vehicle.price ||
          this.vehicle.imageUrl ) ) {
        return true;
      }
      return false;
    }

    // #endregion

    @Watch('callback', { immediate: true, deep: true })
    async reshow (val: boolean, prev: boolean) {
      this.setEmploymentLength()
      this.setAddressLength()
      this.show = false
      setTimeout(async () => {
        await Vue.nextTick()
        this.show = true
      }, 0)
    }
}
